import { recipeImageAttrs, type RecipeImageVariant } from '@/lib/recipe-image';

interface RecipeImageProps {
    src: string;
    alt: string;
    variant: RecipeImageVariant;
    /** Rendered CSS width of a `thumb`, and its aspect ratio if not square. */
    thumbSize?: number;
    thumbAspect?: number;
    className?: string;
}

/**
 * A recipe photo requested at the size it is shown, not the multi-megabyte original.
 * The hero is the main image of its page, so it loads eagerly; everything else is lazy.
 */
export function RecipeImage({
    src,
    alt,
    variant,
    thumbSize = 80,
    thumbAspect,
    className,
}: RecipeImageProps) {
    const attrs = recipeImageAttrs(src, variant, { size: thumbSize, aspect: thumbAspect });
    const isHero = variant === 'hero';
    return (
        <img
            {...attrs}
            alt={alt}
            className={className}
            loading={isHero ? 'eager' : 'lazy'}
            fetchPriority={isHero ? 'high' : undefined}
            decoding="async"
        />
    );
}
